export class Const {
}
Const.RUN_GET_PROFILE_INFO = '/RUN_GET_PROFILE_INFO';
Const.SET_PROFILE_INFO = '/SET_PROFILE_INFO';
Const.GET_PROFILE_INFO = '/GET_PROFILE_INFO';
Const.RUN_GENERATE_2FA_QRCODE = '/RUN_GENERATE_2FA_QRCODE';
Const.RUN_VERIFY_2FA_QRCODE = '/RUN_VERIFY_2FA_QRCODE';
Const.RUN_DISABLE_2FA_QRCODE = '/RUN_DISABLE_2FA_QRCODE';
Const.RUN_GET_PAYMENT_METHODS = '/RUN_GET_PAYMENT_METHODS';
Const.GET_PAYMENT_METHODS = '/GET_PAYMENT_METHODS';
Const.SET_PAYMENT_METHODS = '/SET_PAYMENT_METHODS';
// =================Trading Account list============================
Const.RUN_TRADING_ACCOUNT = '/RUN_TRADING_ACCOUNT_LIST';
Const.GET_TRADING_ACCOUNT = '/GET_TRADING_ACCOUNT_LIST';
Const.SET_TRADING_ACCOUNT = '/SET_TRADING_ACCOUNT_LIST';
// --------------- get news data-----------------------------------
Const.RUN_GET_NEWS_DATA = '/RUN_GET_NEWS_DATA';
Const.GET_NEWS_DATA = '/GET_NEWS_DATA';
Const.SET_NEWS_DATA = '/SET_NEWS_DATA';
// --------------- ECONOMIC CALENDER -------------------------------
Const.RUN_GET_ECONOMIC_CALENDER_DATA = '/RUN_GET_ECONOMIC_CALENDER_DATA';
Const.GET_ECONOMIC_CALENDER_DATA = '/GET_ECONOMIC_CALENDER_DATA';
Const.SET_ECONOMIC_CALENDER_DATA = '/SET_ECONOMIC_CALENDER_DATA';
// --------------------- open Trade ---------------------------------
Const.RUN_GET_OPEN_TRADE = '/RUN_GET_OPEN_TRADE';
Const.GET_OPEN_TRADE = '/GET_OPEN_TRADE';
Const.SET_OPEN_TRADE = '/SET_OPEN_TRADE';
// --------------------- pending order ------------------------------
Const.RUN_GET_PENDING_ORDER = '/RUN_GET_PENDING_ORDER';
Const.GET_PENDING_ORDER = '/GET_PENDING_ORDER';
Const.SET_PENDING_ORDER = '/SET_PENDING_ORDER';
// --------------------- Trade History ------------------------------
Const.RUN_GET_TRADE_HISTORY = '/RUN_GET_TRADE_HISTORY';
Const.GET_TRADE_HISTORY = '/GET_TRADE_HISTORY';
Const.SET_TRADE_HISTORY = '/SET_TRADE_HISTORY';
Const.GET_CALL_TRADE_HISTORY_API = '/GET_CALL_TRADE_HISTORY_API';
Const.SET_CALL_TRADE_HISTORY_API = '/SET_CALL_TRADE_HISTORY_API';
// --------------------- Trade History ------------------------------
Const.RUN_GET_TRANSACTION_HISTORY = '/RUN_GET_TRANSACTION_HISTORY';
Const.GET_TRANSACTION_HISTORY = '/GET_TRANSACTION_HISTORY';
Const.SET_TRANSACTION_HISTORY = '/SET_TRANSACTION_HISTORY';
// --------------------- ACCOUNT BALANCE ------------------------------
Const.RUN_GET_ACCOUNT_BALANCE = '/RUN_GET_ACCOUNT_BALANCE';
Const.GET_ACCOUNT_BALANCE = '/GET_ACCOUNT_BALANCE';
Const.SET_ACCOUNT_BALANCE = '/SET_ACCOUNT_BALANCE';
// --------------------- REMOVED TRADE LIST ------------------------------
Const.RUN_GET_REMOVED_TRADE_LIST = '/RUN_GET_REMOVED_TRADE_LIST';
Const.GET_REJECTED_TRADE = '/GET_REJECTED_TRADE';
Const.SET_REJECTED_TRADE = '/SET_REJECTED_TRADE';
Const.GET_PENDING_TRADE = '/GET_PENDING_TRADE';
Const.SET_PENDING_TRADE = '/SET_PENDING_TRADE';
// --------------------- WS ORDER ------------------------------
Const.GET_WS_ORDER = 'GET_WS_ORDER';
Const.SET_WS_ORDER = 'SET_WS_ORDER';
// ------------------- CURRENCY PAIRS --------------------------
Const.RUN_GET_CURRENCY_PAIRS = '/RUN_GET_CURRENCY_PAIRS';
Const.GET_CURRENCY_PAIRS = '/GET_CURRENCY_PAIRS';
Const.SET_CURRENCY_PAIRS = '/SET_CURRENCY_PAIRS';
// ------------------- CURRENCY PAIRS --------------------------
Const.RUN_GET_PRICE_SHIFT = '/RUN_GET_PRICE_SHIFT';
Const.GET_PRICE_SHIFT = '/GET_PRICE_SHIFT';
Const.SET_PRICE_SHIFT = '/SET_PRICE_SHIFT';
// ------------------- CURRENCY PAIRS --------------------------
Const.RUN_GET_WATCH_LIST = '/RUN_GET_WATCH_LIST';
Const.GET_WATCH_LIST = '/GET_WATCH_LIST';
Const.SET_WATCH_LIST = '/SET_WATCH_LIST';
// ------------------- WATCH LIST --------------------------
Const.RUN_CREATE_WATCH_LIST = '/RUN_CREATE_WATCH_LIST';
Const.RUN_UPDATE_WATCH_LIST = '/RUN_UPDATE_WATCH_LIST';
Const.RUN_DELETE_WATCH_LIST = '/RUN_DELETE_WATCH_LIST';
// ------------------- ORDER BOOK --------------------------
Const.GET_ORDER_BOOK = '/GET_ORDER_BOOK';
Const.SET_ORDER_BOOK = '/SET_ORDER_BOOK';
// ------------------- ORDER BOOK --------------------------
Const.RUN_GET_ACCOUNT_REPORTS = '/RUN_GET_ACCOUNT_REPORTS';
// ------------------- Provider List --------------------------
Const.RUN_GET_PROVIDER_LIST = '/RUN_GET_PROVIDER_LIST';
Const.GET_PROVIDER_LIST = '/GET_PROVIDER_LIST';
Const.SET_PROVIDER_LIST = '/SET_PROVIDER_LIST';
// ------------------- USER ACCOUNTS --------------------------
Const.RUN_GET_USER_ACCOUNTS = '/RUN_GET_USER_ACCOUNTS';
Const.GET_USER_ACCOUNTS = '/GET_USER_ACCOUNTS';
Const.SET_USER_ACCOUNTS = '/SET_USER_ACCOUNTS';
Const.GET_USER_PROFILE = '/GET_USER_PROFILE';
Const.SET_USER_PROFILE = '/SET_USER_PROFILE';
Const.GET_WS_STATUS = '/GET_WS_STATUS';
Const.SET_WS_STATUS = '/SET_WS_STATUS';
Const.RUN_CREATE_DEMO_ACC = '/RUN_CREATE_DEMO_ACC';
// ------------------- USER SETTINGS --------------------------
Const.RUN_SET_USER_SETTINGS = '/RUN_SET_USER_SETTINGS';
Const.RUN_GET_USER_SETTINGS = '/RUN_GET_USER_SETTINGS';
Const.GET_USER_SETTINGS = '/GET_USER_SETTINGS';
Const.SET_USER_SETTINGS = '/SET_USER_SETTINGS';
// ------------------- ACTIVE PRICE ALERT --------------------------
Const.RUN_GET_ACTIVE_PRICE_ALERT = '/RUN_GET_ACTIVE_PRICE_ALERT';
Const.GET_ACTIVE_PRICE_ALERT = '/GET_ACTIVE_PRICE_ALERT';
Const.SET_ACTIVE_PRICE_ALERT = '/SET_ACTIVE_PRICE_ALERT';
// ------------------- TRIGGERED PRICE ALERT --------------------------
Const.RUN_GET_TRIGGERED_PRICE_ALERT = '/RUN_GET_TRIGGERED_PRICE_ALERT';
Const.GET_TRIGGERED_PRICE_ALERT = '/GET_TRIGGERED_PRICE_ALERT';
Const.SET_TRIGGERED_PRICE_ALERT = '/SET_TRIGGERED_PRICE_ALERT';
// ------------------- TRIGGERED PRICE ALERT --------------------------
Const.GET_PRICE_ALERT_NOTIFICATON = '/GET_PRICE_ALERT_NOTIFICATON';
Const.SET_PRICE_ALERT_NOTIFICATON = '/SET_PRICE_ALERT_NOTIFICATON';
// ------------------- PORTFOLIO Data --------------------------
Const.RUN_GET_PORTFOLIO = '/RUN_GET_PORTFOLIO';
Const.GET_PORTFOLIO = '/GET_PORTFOLIO';
Const.SET_PORTFOLIO = '/SET_PORTFOLIO';
Const.RUN_GET_CHART_DATA = '/RUN_GET_CHART_DATA';
// ------------------- GET RAW OBJECT --------------------------
Const.RUN_SET_RAW_OBJECT = '/RUN_SET_RAW_OBJECT';
Const.RUN_GET_RAW_OBJECT = '/RUN_GET_RAW_OBJECT';
Const.GET_RAW_OBJECT = '/GET_RAW_OBJECT';
Const.SET_RAW_OBJECT = '/SET_RAW_OBJECT';
Const.GET_DEFAULT_WORKSPACE_LIST = '/GET_DEFAULT_WORKSPACE_LIST';
Const.GET_APP_THEME = '/GET_APP_THEME';
Const.SET_APP_THEME = '/SET_APP_THEME';
Const.SET_APP_CHART = '/SET_APP_CHART';
Const.GET_APP_CHART = '/GET_APP_CHART';
// ------------------- TECHNICAL_ANALYSIS --------------------------
Const.RUN_GET_TECHNICAL_ANALYSIS = '/RUN_GET_TECHNICAL_ANALYSIS';
Const.GET_TECHNICAL_ANALYSIS = '/GET_TECHNICAL_ANALYSIS';
Const.SET_TECHNICAL_ANALYSIS = '/SET_TECHNICAL_ANALYSIS';
// ------------------- PIVOT_DATA --------------------------
Const.RUN_GET_PIVOT_DATA = '/RUN_GET_PIVOT_DATA';
Const.GET_PIVOT_DATA = '/GET_PIVOT_DATA';
Const.SET_PIVOT_DATA = '/SET_PIVOT_DATA';
// =================Chart Data============================
Const.RUN_GET_TV_CHART_DATA = '/RUN_GET_TV_CHART_DATA';
Const.GET_REGISTER_PROVIDERS = '/GET_REGISTER_PROVIDERS';
Const.SET_REGISTER_PROVIDERS = '/SET_REGISTER_PROVIDERS';
// ================ Copy tarde ==========================
Const.RUN_GET_LEADERS_LIST = '/RUN_GET_LEADERS_LIST';
Const.GET_LEADERS_LIST = '/GET_LEADERS_LIST';
Const.SET_LEADERS_LIST = '/SET_LEADERS_LIST';
Const.RUN_GET_LEADER_DETAIL = '/RUN_GET_LEADER_DETAIL';
Const.GET_LEADER_DETAIL = '/GET_LEADER_DETAIL';
Const.SET_LEADER_DETAIL = '/SET_LEADER_DETAIL';
Const.GET_LEADER_FILTES = '/GET_LEADER_FILTES';
Const.RUN_GET_PROFIT_CHART_DATA = '/RUN_GET_PROFIT_CHART_DATA';
Const.SET_PROFIT_CHART_DATA = '/SET_PROFIT_CHART_DATA';
Const.GET_PROFIT_CHART_DATA = '/GET_PROFIT_CHART_DATA';
Const.RUN_GET_PERFORMANCE_CHART_DATA = '/RUN_GET_PERFORMANCE_CHART_DATA';
Const.SET_PERFORMANCE_CHART_DATA = '/SET_PERFORMANCE_CHART_DATA';
Const.GET_PERFORMANCE_CHART_DATA = '/GET_PERFORMANCE_CHART_DATA';
Const.RUN_GET_PORTFOLIO_CHART_DATA = '/RUN_GET_PORTFOLIO_CHART_DATA';
Const.SET_PORTFOLIO_CHART_DATA = '/SET_PORTFOLIO_CHART_DATA';
Const.GET_PORTFOLIO_CHART_DATA = '/GET_PORTFOLIO_CHART_DATA';
Const.RUN_GET_DRAWDOWN_CHART_DATA = '/RUN_GET_DRAWDOWN_CHART_DATA';
Const.SET_DRAWDOWN_CHART_DATA = '/SET_DRAWDOWN_CHART_DATA';
Const.GET_DRAWDOWN_CHART_DATA = '/GET_DRAWDOWN_CHART_DATA';
Const.RUN_GET_LEADER_TRADE_HISTORY = '/RUN_GET_LEADER_TRADE_HISTORY';
Const.SET_LEADER_TRADE_HISTORY = '/SET_LEADER_TRADE_HISTORY';
Const.GET_LEADER_TRADE_HISTORY = '/GET_LEADER_TRADE_HISTORY';
Const.RUN_GET_ALL_LEADERS_LIST = '/RUN_GET_ALL_LEADERS_LIST';
Const.GET_ALL_LEADERS_LIST = '/GET_ALL_LEADERS_LIST';
Const.SET_ALL_LEADERS_LIST = '/SET_ALL_LEADERS_LIST';
Const.RUN_GET_FOLLOWERS_SETTING = '/RUN_GET_FOLLOWERS_SETTING';
Const.GET_FOLLOWERS_SETTING = '/GET_FOLLOWERS_SETTING';
Const.SET_FOLLOWERS_SETTING = '/SET_FOLLOWERS_SETTING';
Const.RUN_FOLLOW_TRADE = '/RUN_FOLLOW_TRADE';
Const.RUN_GET_USER_EQUITY_CHART_WITH_LEADER = '/RUN_GET_USER_EQUITY_CHART_WITH_LEADER';
Const.GET_USER_EQUITY_CHART_WITH_LEADER = '/GET_USER_EQUITY_CHART_WITH_LEADER';
Const.SET_USER_EQUITY_CHART_WITH_LEADER = '/SET_USER_EQUITY_CHART_WITH_LEADER';
Const.RUN_GET_USER_COPYTRADING_TOKEN = '/RUN_GET_USER_COPYTRADING_TOKEN';
Const.GET_USER_COPYTRADING_TOKEN = '/GET_USER_COPYTRADING_TOKEN';
Const.SET_USER_COPYTRADING_TOKEN = '/SET_USER_COPYTRADING_TOKEN';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/provider/lib/const.cls.ts
// module id = CPps
// module chunks = 4